var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef } from 'react';
import styled from 'styled-components';
import { useDropdown } from "../Dropdown";
import { DatetimeSelector } from './DatetimeSelector';
import { createUIElement } from "../../helpers";
import { createDefaultDatetimeInputControl } from './renderer';
import { useControlState } from '../helpers/useControlState';
import { KeyCode } from "../../helpers/keyCode";
import { DEFAULT_TEXTS } from './helpers';
import { CONTROL_SIZE } from "../../common/public";
var PopoverBody = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: 16px;\n"], ["\n    padding: 16px;\n"])));
export var DatetimeInput = createUIElement('DatetimeInput', function (_a, ref) {
    var className = _a.className, disabled = _a.disabled, value = _a.value, onChange = _a.onChange, size = _a.size, error = _a.error, _b = _a.withTime, withTime = _b === void 0 ? false : _b, rightSectionRenderer = _a.rightSectionRenderer, _c = _a.is12Hours, is12Hours = _c === void 0 ? false : _c, _d = _a.startDatetime, startDatetime = _d === void 0 ? new Date(0) : _d, placeholder = _a.placeholder, _e = _a.endDatetime, endDatetime = _e === void 0 ? new Date(9999, 11, 31) : _e, isDisabledDate = _a.isDisabledDate, onDateError = _a.onDateError, texts = _a.texts, _f = _a.highlightDates, highlightDates = _f === void 0 ? [] : _f, _g = _a.controlRenderer, controlRenderer = _g === void 0 ? createDefaultDatetimeInputControl() : _g, footerRenderer = _a.footerRenderer, hasEnterKeyStopPropagation = _a.hasEnterKeyStopPropagation, manualCloseMode = _a.manualCloseMode, _h = _a.showCurrentDate, showCurrentDate = _h === void 0 ? true : _h, onMonthChange = _a.onMonthChange, onDateChange = _a.onDateChange, onFocus = _a.onFocus, onBlur = _a.onBlur, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "disabled", "value", "onChange", "size", "error", "withTime", "rightSectionRenderer", "is12Hours", "startDatetime", "placeholder", "endDatetime", "isDisabledDate", "onDateError", "texts", "highlightDates", "controlRenderer", "footerRenderer", "hasEnterKeyStopPropagation", "manualCloseMode", "showCurrentDate", "onMonthChange", "onDateChange", "onFocus", "onBlur", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var rootRef = useRef(null);
    var buttonRef = ref || rootRef;
    var uiTexts = __assign(__assign({}, DEFAULT_TEXTS), texts);
    var _j = useControlState({
        onFocus: onFocus,
        onBlur: onBlur,
        rootRef: buttonRef
    }), focused = _j.focused, active = _j.active, activate = _j.activate, _k = _j.input, onFocusInput = _k.onFocus, onBlurInput = _k.onBlur, preventBlur = _j.preventBlur;
    var defaultSize = withTime ? CONTROL_SIZE.s : CONTROL_SIZE.xs;
    var control = useDropdown({
        offset: 1,
        ref: buttonRef,
        renderControl: function (_a) {
            var button = _a.button, isActive = _a.isActive, dropdownActions = _a.actions;
            var actions = {
                open: function () {
                    if (disabled || isActive) {
                        return;
                    }
                    dropdownActions === null || dropdownActions === void 0 ? void 0 : dropdownActions.show();
                    activate();
                },
                close: function () {
                    if (disabled || !isActive) {
                        return;
                    }
                    dropdownActions === null || dropdownActions === void 0 ? void 0 : dropdownActions.hide();
                    activate();
                }
            };
            return controlRenderer(__assign(__assign({}, rest), { className: "vm-DatetimeInput " + className, testId: rest['data-selector-id'], error: !!error, size: size || defaultSize, disabled: !!disabled, active: active, opened: isActive, actions: actions,
                focused: focused, value: value, startDatetime: startDatetime,
                endDatetime: endDatetime,
                hasEnterKeyStopPropagation: hasEnterKeyStopPropagation,
                placeholder: placeholder,
                onChange: onChange, onValueError: onDateError, withTime: withTime,
                is12Hours: is12Hours, texts: {
                    am: uiTexts.am,
                    pm: uiTexts.pm
                }, style: style, control: {
                    ref: button.ref,
                    onFocus: onFocusInput,
                    onBlur: onBlurInput,
                    onClick: onClick,
                    onMouseDown: function (e) {
                        e.stopPropagation();
                        actions.open();
                        onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(e);
                    },
                    onMouseUp: onMouseUp,
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave,
                    onKeyDown: function (e) {
                        if (e.keyCode === KeyCode.Space && !disabled) {
                            isActive ? actions.close() : actions.open();
                        }
                        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
                    },
                    onKeyUp: onKeyUp,
                    onKeyPress: onKeyPress
                } }));
        },
        renderContent: function (_a) {
            var actions = _a.actions;
            return (React.createElement(PopoverBody, null,
                React.createElement(DatetimeSelector, { onMouseDown: preventBlur, value: value, rightSectionRenderer: rightSectionRenderer, withTime: !!withTime, is12Hours: !!is12Hours, startDatetime: startDatetime, endDatetime: endDatetime, isDisabledDate: isDisabledDate, onRequestClose: actions.hide, onSelect: onChange, texts: uiTexts, highlightDates: highlightDates, showCurrentDate: showCurrentDate, manualCloseMode: manualCloseMode, onMonthChange: onMonthChange, onDateChange: onDateChange, footerRenderer: footerRenderer })));
        }
    })[0];
    return control;
});
var templateObject_1;
//# sourceMappingURL=DatetimeInput.js.map